import { Radio, Stack, TableCell, Typography, useTheme } from "@mui/material"

export function RowSelector({ onChange, selected, index }) {
    const checked = index === selected
    const theme = useTheme()
    return (
        <TableCell
            sx={{
                position: "sticky",
                left: 0,
                bgcolor: theme.palette.background.paper + "b0",
                backdropFilter: "blur(6px)",
            }}
        >
            <Stack direction="row" alignItems="center">
                <Radio
                    onClick={() => onChange(index)}
                    sx={{ mr: 1 }}
                    checked={checked}
                    data-cy={`row-selector-checkbox-${index}`}
                />
                <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                    {index}
                </Typography>
            </Stack>
        </TableCell>
    )
}
